module.exports = __webpack_public_path__ + "img/Group1.688e0549.png";